function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

function hideDelayedContent() {
  const sections = document.querySelectorAll('.shopify-section');
  let startSection = null;
  let delaySeconds = 0;
  let sectionId = null;
  let sectionsToShow = [];

  const isInShopifyEditor = Shopify && Shopify.designMode === true;

  let enableCookie = false;
  let cookieName = '';

  sections.forEach((section) => {
    if (section.classList.contains('qlf-delayed-content-start')) {
      startSection = section;
      const delayElement = section.querySelector('[data-delay-seconds]');
      delaySeconds = parseInt(
        delayElement ? delayElement.getAttribute('data-delay-seconds') : '0',
        10
      );
      enableCookie = delayElement
        ? delayElement.getAttribute('data-enable-cookie') === 'true'
        : false;
      sectionId = delayElement ? delayElement.getAttribute('data-section-id') : null;
      return;
    }
  });

  if (!startSection || delaySeconds <= 0 || !sectionId) {
    return;
  }

  cookieName = `qlf_delayed_content_${window.location.pathname.replace(/\//g, '_')}_${sectionId}`;

  /* Finde alle Sections, die bereits markiert wurden */
  sectionsToShow = Array.from(
    document.querySelectorAll('.shopify-section[data-qlf-delayed-group="' + sectionId + '"]')
  );

  const hasCookie = getCookie(cookieName) === 'true';

  /* Im Shopify Editor oder wenn Cookie gesetzt: Sections sofort anzeigen */
  if (isInShopifyEditor || hasCookie) {
    sectionsToShow.forEach((section) => {
      section.removeAttribute('data-qlf-pending');
      section.classList.add('qlf-delayed-content-visible');
    });
    return;
  }

  /* Nach der Verzögerung: Sections anzeigen */
  if (sectionsToShow.length > 0) {
    setTimeout(() => {
      sectionsToShow.forEach((section) => {
        /* Entferne data-Attribut - CSS versteckt die Section nicht mehr */
        section.removeAttribute('data-qlf-pending');
        section.classList.add('qlf-delayed-content-visible');
      });

      /* Feuere Custom Event für andere Sections (z.B. Carousels) */
      window.dispatchEvent(
        new CustomEvent('qlf:delayedContentVisible', {
          detail: {
            sectionId: sectionId,
            sections: sectionsToShow
          }
        })
      );

      const delayElement = startSection.querySelector('[data-auto-scroll]');
      const autoScroll = delayElement
        ? delayElement.getAttribute('data-auto-scroll') === 'true'
        : false;

      if (autoScroll && sectionsToShow.length > 0) {
        const firstSection = sectionsToShow[0];
        firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (enableCookie) {
        setCookie(cookieName, 'true', 30);
      }
    }, delaySeconds * 1000);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  hideDelayedContent();
});
